import { ReactComponent as More16 } from '../../../../assets/svg/More16.svg'
import { Button, BUTTON_TYPES } from '../../../../components/Button'
import { BTN_TXT } from '../../../../constants'
import {
  ability,
  ACTIONS,
  SUBJECTS,
  SubjectWithAttributes
} from '../../../Permission'
import { routes } from '../../../../router'
import { useNavigate } from 'react-router'
import { setLoading } from '../../../../redux/store/common/slice'
import { getHealthSystemQRCOde } from '../../../HealthSystemDetails/HospitalsTable/api'
import { useDispatch } from 'react-redux'
import { subject } from '@casl/ability'
import { useCallback, useMemo } from 'react'

export const ActionCell = ({ hsUuid }: { hsUuid: string }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClick = useCallback(
    async (key: string) => {
      try {
        dispatch(setLoading(true))
        const response = await getHealthSystemQRCOde(hsUuid, key)
        if (!response?.data?.qr_code) return
        window.open(response?.data?.qr_code, '_blank')
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(setLoading(false))
      }
    },
    [dispatch, hsUuid]
  )

  const canGenerateQrCode = ability.can(
    ACTIONS.VIEW,
    subject(SUBJECTS.MY_ORGANIZATION_COMMUNITY_HS_TABLE_ACTIONS, {
      uuid: hsUuid
    } as unknown as SubjectWithAttributes)
  )
  const canEditHsDetails =
    ability.can(
      ACTIONS.EDIT,
      subject(SUBJECTS.HEALTH_SYSTEM, {
        uuid: hsUuid
      } as unknown as SubjectWithAttributes)
    ) || ability.can(ACTIONS.CRUD, SUBJECTS.HEALTH_SYSTEM)

  const actions = useMemo(() => {
    const options = [
      {
        text: BTN_TXT.EDIT,
        onClick: () => {
          navigate(
            `${routes.myCommunity}${routes.myOrganization}/health_systems/${hsUuid}`,
            {
              replace: true
            }
          )
        },
        hidden: !canEditHsDetails
      },
      {
        text: BTN_TXT.GENERATE_QR_CODE_AS_IMAGE,
        onClick: () => handleClick('image'),
        hidden: !canGenerateQrCode
      },
      {
        text: BTN_TXT.GENERATE_QR_CODE_AS_PDF,
        onClick: () => handleClick('pdf'),
        hidden: !canGenerateQrCode
      }
    ]
    return options?.filter((item) => !item?.hidden)
  }, [canEditHsDetails, canGenerateQrCode, handleClick, hsUuid, navigate])

  return (
    <Button.Menu
      icon={<More16 />}
      type={BUTTON_TYPES.GHOST}
      options={actions}
      iconOnly
      hideArrow
      medium
    />
  )
}
